export default __webpack_public_path__ + "static/media/929.21cccbe2.png";